import { EditorPlugin } from '@draft-js-plugins/editor';
import { MentionSuggestionsPubProps } from '@draft-js-plugins/mention/lib/MentionSuggestions/MentionSuggestions';
import createMentionPlugin, { defaultTheme } from '@draft-js-plugins/mention';
import React, { useMemo } from 'react';

export type MentionsPlugin = EditorPlugin & {
	MentionSuggestions: React.ComponentType<MentionSuggestionsPubProps>;
};

export interface UseEditorMentionsResult<T extends EditorPlugin> {
	MentionSuggestions: React.ComponentType<MentionSuggestionsPubProps>;
	plugins: (MentionsPlugin | T)[];
}

export function useEditorMentions<T extends EditorPlugin>(
	originalPlugins: T[],
	enabled: boolean
): UseEditorMentionsResult<T> {
	const result = useMemo(() => {
		const conditionalMentionPlugin = [];
		const mentionPlugin = createMentionPlugin({
			entityMutability: 'IMMUTABLE',
			mentionPrefix: '@',
			supportWhitespace: true,
			theme: {
				...defaultTheme,
				mention: 'mention'
			}
		});

		if (enabled) {
			conditionalMentionPlugin.push(mentionPlugin);
		}

		return {
			MentionSuggestions: mentionPlugin.MentionSuggestions,
			plugins: [ ...originalPlugins, ...conditionalMentionPlugin ]
		};
	}, [ enabled, originalPlugins ]);

	return result;
}
